export const autoBrandDiscard = 'auto-brand-discard-modal';
export const autoBrandModal = 'auto-brand-modal';
export const WEBSITE_REGEX =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,13}(:[0-9]{1,5})?(\/.*)?$/;

// should match E1: defaultFonts in assets/js/src/brand/reducers/fonts.js
export const DEFAULT_BRAND_FONTS = {
  subtitle: {
    fontFamily: 'Roboto Condensed',
    fontSize: 30,
    bold: false,
    italic: false,
    underline: false,
  },
  text: {
    fontFamily: 'Roboto Condensed',
    fontSize: 20,
    bold: false,
    italic: false,
    underline: false,
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: 50,
    bold: true,
    italic: false,
    underline: false,
  },
};

export const autoBrandModalsIds = [autoBrandModal, autoBrandDiscard];
